module.exports = __webpack_public_path__ + "static/media/home-delivery-menu-14-jan-2021.46fe7a50.jpg";